<template>
  <div>
    <span>
      举报管理
    </span>
  </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped>

</style>
